/**
 * @file: description
 * @author: dongjing
 * @Date: 2020-01-13 17:19:41
 * @LastEditors: dongjing
 * @LastEditTime: 2020-01-16 13:37:44
 */
import React, { useState, useEffect } from 'react';
import { IconFont } from '@src/features/common';
import './WriteMenu.less';
import { Link } from 'react-router-dom';
interface Props {}

const WriteMenu: React.SFC<Props> = (props: Props) => {
  return (
    <div className="write-menu">
      <div className="write-top"></div>
      <div className="home-menu">
        <div className="sub-menu">
          <Link className="menu-item" to="/article/edit" target="_blank">
            <IconFont type="icon-wenzhang" className="item-icon" />
            <span className="sub-menu-title">发布文章</span>
          </Link>
          <span className="shu"></span>
          <Link className="menu-item" to="/ask/ask-edit/DRAFT" target="_blank">
            <IconFont type="icon-wenda" className="item-icon" />
            <span className="sub-menu-title">我要提问</span>
          </Link>
          <span className="shu"></span>
          <Link className="menu-item" to="/vote/edit" target="_blank">
            <IconFont type="icon-toupiao" className="item-icon" />
            <span className="sub-menu-title">发起投票</span>
          </Link>
        </div>
        <Link className="my-draft" to="/articles/article/1">
          <IconFont type="icon-draft" />
          <span>我的草稿</span>
        </Link>
      </div>
    </div>
  );
};
export default WriteMenu;
